import(/* webpackMode: "eager" */ "/app/app/indicators/investigator/trends/page.jsx");
